import { graphql } from "api/cms-website/generated";

import { ResponsiveImageFragment } from "../primitives/responsiveImage";

export const LargePictureFragment = graphql(/* GraphQL */ `
    fragment LargePictureFragment on ComponentComponentsLargePicture {
        id
        noMarginBottom
        image {
            ...ResponsiveImageFragment
        }
    }
    ${ResponsiveImageFragment}
`);
